import { IsiIWSAssociatedViewContext } from "../GridView/AssociatedView/IsiIwsAssociatedViewContext";
import { getInstanceForModif } from "../../form.ts";
import { IIsiUIFlowResult } from "./IIsiUIFlowResult";
import { IsiPlInstanceScreen } from "../PresentationLogic/IsiPlInstanceScreen";

/**
 * Cette classe regroupe ce qui lié à l'interaction de l'utilisateur avec le produit
 **/
export class IsiInteraction {

    private _comeFromAssociatedView: boolean;

    /**
     * Déclenche la popin de selection de l'instance à utiliser (ex : sur l'association sur une DA)
     * @param detailName Le code de la DA pour laquelle on souhaite ouvrir la popin de selection d'instance
     */
    promptChooseInstance(associatedViewContext: IsiIWSAssociatedViewContext): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            if (screenCore.currentScreen.isCurrentScreenNotTypeScripted) {
                if (typeof (window.beforeChooseInstance_Overridable) !== "undefined") {
                    if (window.beforeChooseInstance_Overridable(associatedViewContext.name)) {
                        this.launchPromptChooseInstance(associatedViewContext, function () { resolve({ result: true, continue: uiCore.getSubmit() }); });
                    }
                    else {
                        resolve({ result: true, continue: uiCore.getSubmit() });
                    }
                } else {
                    resolve({ result: true, continue: uiCore.getSubmit() });
                }
            } else {
                screenCore.currentScreen.beforeChooseInstance(associatedViewContext).then((prompt) => {
                    if (prompt) {
                        this.launchPromptChooseInstance(associatedViewContext, function () { resolve({ result: true, continue: uiCore.getSubmit() }); });
                    } else {
                        resolve({ result: true, continue: uiCore.getSubmit() });
                    }
                })
            }
        })
    }

    private launchPromptChooseInstance(associatedViewContext: IsiIWSAssociatedViewContext, callbackFn: Function) {
        screenCore.associatedViewManager.promptChooseInstance(associatedViewContext, callbackFn);
    }


    /**
     * Indique si l'action provient de la DA (ex : on a cliquer sur associer)
     */
    get comeFromAssociatedView() {
        return this._comeFromAssociatedView;
    }

    /**
     * Définie si l'action provient de la DA (ex : on a cliquer sur associer)
     */
    set comeFromAssociatedView(value) {
        this._comeFromAssociatedView = value;
    }
}